import "./TheFlightPlan.module.css";
import Header from "@/reusable_sections/Header";
import PhaseITheAssessment from "./sections/PhaseITheAssessment";
import PhaseIiStructuredPlanning from "./sections/PhaseIiStructuredPlanning";
import PhaseIiiCareDelivery from "./sections/PhaseIiiCareDelivery";
import Footer from "@/reusable_sections/Footer";
export default function TheFlightPlanPage() {
  return <div>
      <Header />
      <PhaseITheAssessment />
      <PhaseIiStructuredPlanning />
      <PhaseIiiCareDelivery />
      <Footer />
    </div>;
}